import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import { AppDispatch } from "../../app/store";
import { AuthState, useAuth } from './auth';
import { refreshToken } from "./authSlice";

interface RequireAuthProps {
  children: JSX.Element
};

const RequireAuth = ({ children }: RequireAuthProps) => {
  let auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (auth.state === AuthState.Idle) {
      console.log("Initial load, fetching auth token...")
      dispatch(refreshToken());
    }
  }, [auth.state, dispatch]);

  switch (auth.state) {
    case AuthState.Idle:
      return (<></>);
    case AuthState.Loading:
      return (<div>Signing in...</div>);
    case AuthState.SignedIn:
      return children;
    default:
      return (<Navigate to="/login" />);
  }
}

export default RequireAuth;
